import { Link } from 'react-router-dom';

export default function Services() {
  const services = [
    {
      title: 'Erhvervs Vinduespolering',
      description: 'Professionel vinduespolering til butikker, kontorer, klinikker, erhvervsbygninger og ejendomme. Få et professionelt førstehåndsindtryk med faste aftaler og fleksibel planlægning.',
      path: '/ydelser/erhvervs-vinduespolering',
      icon: 'fa-duotone fa-building',
      benefits: ['Professionelt førstehåndsindtryk', 'Faste, pålidelige aftaler', 'Fleksibel planlægning', 'Butikker, kontorer & klinikker'],
    },
    {
      title: 'Privat Vinduespolering',
      description: 'Skinnende rene vinduer in dit hjem. Vi pudser både ude og inde i parcelhuse, villaer, lejligheder og sommerhuse med stor omhu og respekt for dit hjem.',
      path: '/ydelser/privat-vinduespolering',
      icon: 'fa-duotone fa-house',
      benefits: ['Rene vinduer i hjemmet', 'Fleksible aftaler', 'Ude- og indvendig pudsning', 'Pæn og tryg service'],
    },
    {
      title: 'Tagrende rens',
      description: 'Effektiv og sikker rensning af tagrender. Vi fjerner blade, skidt og snavs for at forebygge tilstoppede tagrender, overløb og potentielle vandskader.',
      path: '/ydelser/tagrende-rens',
      icon: 'fa-duotone fa-water-gutter',
      benefits: ['Fjernelse af blade & skidt', 'Forebyggelse af vandskader', 'Bedre vandafledning', 'Praktisk service'],
    },
  ];

  return (
    <>
      {/* React 19 Native Metadata Hoisting */}
      <title>Ydelser - Nygaards Vinduespolering</title>
      <meta
        name="description"
        content="Se ydelser hos Nygaards Vinduespolering, herunder erhvervs vinduespolering, privat vinduespolering og tagrende rens."
      />

      {/* Hero Header */}
      <section className="bg-slate-50/70 py-20 border-b border-slate-100">
        <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8">
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-brand-orange">
            Hvad kan vi hjælpe med?
          </span>
          <h1 className="mt-3 font-display text-3xl font-bold uppercase tracking-wider text-brand-blue sm:text-4xl">
            Vores ydelser
          </h1>
          <div className="mx-auto mt-4 h-0.5 w-12 bg-brand-orange" />
          <p className="mx-auto mt-6 max-w-2xl text-sm font-light leading-relaxed text-slate-500">
            Vi tilbyder professionel vinduespolering og tagrenderensning til både private og erhverv i Kerteminde og omegn.
          </p>
        </div>
      </section>

      {/* Ydelser Grid */}
      <section className="bg-white py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
            {services.map((service) => (
              <Link
                key={service.title}
                to={service.path}
                className="group flex flex-col rounded-none border border-slate-200 bg-white p-8 shadow-none transition-all duration-300 hover:border-brand-blue/40"
              >
                <h2 className="font-display text-lg font-bold uppercase tracking-wider text-brand-dark group-hover:text-brand-blue transition-colors">
                  {service.title}
                </h2>
                <p className="mt-4 flex-grow text-xs font-light leading-relaxed text-slate-500">
                  {service.description}
                </p>

                {/* Fordele liste */}
                <ul className="mt-6 space-y-2 border-t border-slate-100 pt-6">
                  {service.benefits.map((benefit, idx) => (
                    <li key={idx} className="flex items-center gap-2 text-xs font-light text-slate-500">
                      <i className="fa-solid fa-check text-brand-blue" />
                      <span>{benefit}</span>
                    </li>
                  ))}
                </ul>

                <div className="mt-8 flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-brand-blue group-hover:text-brand-orange transition-colors">
                  Læs mere om ydelsen <i className="fa-solid fa-arrow-right transition-transform group-hover:translate-x-1" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Sektion */}
      <section className="bg-slate-50/70 py-20 border-t border-slate-100">
        <div className="mx-auto max-w-5xl px-4 text-center sm:px-6 lg:px-8">
          <h2 className="font-display text-2xl font-bold uppercase tracking-wider text-brand-dark">
            Har du en speciel opgave?
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-xs font-light leading-relaxed text-slate-500">
            Vi løser også specialopgaver og skræddersyr gerne en aftale, der passer præcis til din ejendom eller virksomhed. Kontakt os for en uforpligtende snak.
          </p>
          <div className="mt-8 flex justify-center">
            <Link
              to="/kontakt"
              className="rounded-full bg-brand-blue px-8 py-4 font-display text-xs font-bold uppercase tracking-[0.2em] text-white hover:bg-brand-orange transition-all duration-300 hover:scale-105"
            >
              Kontakt os i dag
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
